import { v4 as uuidv4 } from 'uuid';

export const productsAndBatchInfoHelper = (selectedData, lineKey, productInfoKey, batchesKey) => {
  const tempProductsAndBatchInfo = selectedData?.[lineKey]?.filter((lineData) => lineData?.[batchesKey]?.length)?.map((lineData) => ({
    key: uuidv4(),
    product_sku_name: lineData?.[productInfoKey]?.product_sku_name,
    internal_sku_code: lineData?.[productInfoKey]?.internal_sku_code,
    product_sku_id: lineData?.[productInfoKey]?.product_sku_id,
    product_batches: lineData?.[batchesKey]?.map((productBatches) => ({
      key: uuidv4(),
      batch_id: productBatches?.batch_id,
      custom_batch_number: productBatches?.custom_batch_number || productBatches?.batch_number,
      copies: 0,
    })),
  }));
  return tempProductsAndBatchInfo;
};

export const handleChangeCopiesHelper = (productsAndBatchInfo, value, childKey, parentKey) => {
  let tempProductsAndBatchInfo = JSON.parse(JSON.stringify(productsAndBatchInfo));
  tempProductsAndBatchInfo = tempProductsAndBatchInfo?.map((data) => {
    if (data?.key === parentKey) {
      return {
        ...data,
        product_batches: data?.product_batches?.map((batchData) => {
          if (batchData?.key === childKey) {
            return {
              ...batchData,
              copies: value,
            };
          }
          return batchData;
        }),
      };
    }
    return data;
  });

  return tempProductsAndBatchInfo;
};

export const handleChangeProductCopiesHelper = (productsAndBatchInfo, value, key) => {
  let tempProductsAndBatchInfo = JSON.parse(JSON.stringify(productsAndBatchInfo));
  tempProductsAndBatchInfo = tempProductsAndBatchInfo?.map((data) => {
    if (data?.key === key) {
      return {
        ...data,
        product_batches: data?.product_batches?.map((batchData) => ({
          ...batchData,
          copies: value,
        })),
      };
    }
    return data;
  });
  return tempProductsAndBatchInfo;
};
